const horizontalAlignmentMap = {
  center: "center",
  left: "start",
  right: "end",
};

const verticalAlignmentMap = {
  bottom: "end",
  center: "center",
  top: "start",
};

export { horizontalAlignmentMap, verticalAlignmentMap };
